export const Error = ({ message }) => {
  return <div className="alert alert-danger my-3">{message}</div>;
};
